
import { IItemSolicitacaoTecnicaModel } from "./../../../../models/item-solicitacao-tecnica.model";
import { IResponsavelModel } from "./../../../../models/responsaveis.model";
import { IUnidadeGestoraModel } from "./../../../../models/unidade-gestora.model";
import { ISolicitacaoTecnicaModel } from "./../../../../models/solicitacao-tecnica.model";
import { SolicitacaoTecnicaService } from "./../../../../services/solicitacao-tecnica.service";
import { OsaExecucaoModalIncluirItemComponent } from "../modal-incluir-item/osa-execucao-modal-incluir-item.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import {
	Component,
	Inject,
	OnInit,
	ViewChild,
	AfterViewInit,
} from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import {
	MatDialog,
	MatDialogConfig,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import Swal from "sweetalert2";
import { IEnumModel } from "../../../../models/enum.model";
import { OsaExecucaoModalAvaliarProrrogacaoComponent } from "../modal-avaliar-prorrogacao/osa-execucao-modal-avaliar-prorrogacao.component";
import { EnumTipoSolicitacaoTecnica } from "../../../../models/enum/tipo-solicitacao-tecnica.enum";
import { skip } from 'rxjs/operators';
import { AuthService } from "../../../../services/auth.service";
import {
  ModalJustificativaComponent
} from "../../../../shared/components/modal-justificativa/modal-justificativa.component";
import { angularEditorConfig } from "../../../../shared/util/angularEditorConfig";
@Component({
	selector: "app-modal-incluir-solicitacao",
	templateUrl: "./osa-execucao-modal-incluir-solicitacao.component.html",
	styleUrls: ["./osa-execucao-modal-incluir-solicitacao.component.scss"],
})
	export class OsaExecucaoIncluirSolicitacaoComponent implements OnInit, AfterViewInit {

	public editorConfig: AngularEditorConfig = angularEditorConfig(
		"Digite a descrição",
		"200px",
		"100%"
	);
	public editorMaxLength = 2000;
	public dataSourceItems = new MatTableDataSource<IItemSolicitacaoTecnicaModel>([]);
	public visualizar: boolean;
	public titulo: string = "";
	public model: ISolicitacaoTecnicaModel = {} as ISolicitacaoTecnicaModel;
	public submitted: boolean;
	public unidadesGetoras: IUnidadeGestoraModel[];
	public responsaveis: IResponsavelModel[];
	public ugSelecionada: number;
	public permitidoIncluir: boolean;
	public tipoTrabalho: IEnumModel = {} as IEnumModel;
	public planejamentoId: number;
	public prorrogacao = true
	public numeroST: string;
	public enumTipoSolicitacao = EnumTipoSolicitacaoTecnica;
	public tiposSolicitacaoTecnica: { text: string, value: number }[] = [];
	IEnumModel = {} as IEnumModel;
	public telefoneFormatado: string = '';
	public dataHoje: Date = this.truncateDate(new Date());
	public dataPrazoLimite: Date;
	public acaoCancelarItem: boolean;

	valorOriginal!: any;
	habilitaFinalizarEnviar: boolean = false;

	public incluirSolicitacao: FormGroup = this.fb.group({
		tipo: ["", Validators.required],
		internaUnidadeGestoraId: [""],
		internaResponsavelId: [""],
		externaDestinatarioNome: [""],
		externaDestinatarioResponsavel: [""],
		externaDestinatarioCPFCNPJ: ["", cpfCnpjValidator],
		externaDestinatarioFone: [""],
		externaDestinatarioEmail: [""],
		assunto: ["", Validators.required],
		descricao: ["", Validators.required],
		prazoResposta: ["", [Validators.required, this.dateRangeValidator.bind(this)]],
	});

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild("maxLengthEditor") private angularEditor: any;

	constructor(
		private fb: FormBuilder,
		public matDialog: MatDialog,
		public serviceSolicitacao: SolicitacaoTecnicaService,
		private dialogRef: MatDialogRef<OsaExecucaoIncluirSolicitacaoComponent>,
		private authService: AuthService,
		@Inject(MAT_DIALOG_DATA) public data
	) {
		if (data?.id) {
			this.model.id = data?.id;
		}
		this.visualizar = data?.visualizar;
		this.titulo = data?.titulo;
		this.model.status = data?.status;
		this.model.tipoTrabalhoId = data?.tipoTrabalhoId;
		this.model.documentoAssociado = data?.documentoAssociado;
		this.tipoTrabalho = data.tipoTrabalho;
		this.planejamentoId = data?.planejamentoId;
		this.numeroST = data?.numeroST;
		this.dataPrazoLimite = this.truncateDate(data?.dataLimite);
		this.acaoCancelarItem = data?.acaoCancelarItem;
	}

	ngOnInit(): void {

		this.obterUG().then(() => {
			this.carregarTipoSolicitacaoTecnica();
			if (this.model?.id) {
				this.obterPorId();
			}
		});

		this.controlaTipo();

		this.dataSourceItems.paginator = this.paginator;
		this.dataSourceItems.sort = this.sort;
		this.dataSourceItems.sortingDataAccessor = this.sortingDataAccessor

		this.incluirSolicitacao.valueChanges.subscribe(() => {
			if (this.valorOriginal && !this.formsIguais(this.valorOriginal, this.incluirSolicitacao.value)) {
				this.habilitaFinalizarEnviar = false;
			}
			else {
				this.habilitaFinalizarEnviar = true;
			}
		});
	}

	ngAfterViewInit() {

		function maxLengthAngularEditor(e: any) {
			var element = e.target as HTMLTextAreaElement;
			let permitirTeclas =
				e.key !== "Backspace" &&
				e.key !== "ArrowLeft" &&
				e.key !== "ArrowRight";
			if (element.innerHTML.length === 2000 && permitirTeclas) {
				e.preventDefault();
			}
		}

		this.angularEditor?.textArea?.nativeElement.addEventListener(
			"keydown",
			maxLengthAngularEditor,
			false
		);
	}

	onEditorChange(content: string) {
		if (content.length > this.editorMaxLength) {
			// corta automaticamente para 2000 caracteres
			this.incluirSolicitacao.get('descricao')?.setValue(content.substring(0, this.editorMaxLength), { emitEvent: false });
		}
	}

	public sortingDataAccessor = (item, property) => {
		switch (property) {
			case "ug":
				return item?.unidadeGestora?.text;
			case "responsavel":
				return item?.responsavel?.text;
			case "tituloItem":
				return item?.titulo;
			case "numero":
				return item?.numero;
			case "status":
				return item?.status?.descricao;
			default:
				return item[property];
		}
	};

	public obterPorId() {
		this.serviceSolicitacao.obterPorId(this.model?.id).then((res) => {
			if (res.sucesso) {
				this.dataSourceItems =
					new MatTableDataSource<IItemSolicitacaoTecnicaModel>(
						res.dados.item
					);

				if (res.dados.internaUnidadeGestoraId)
					this.obterResponsaveis(res.dados.internaUnidadeGestoraId);

				this.incluirSolicitacao.controls["prazoResposta"].setValue(new Date(res.dados.prazo));
				this.incluirSolicitacao.controls["tipo"].setValue(res.dados.tipo);
				this.incluirSolicitacao.controls["internaUnidadeGestoraId"].setValue(res.dados.internaUnidadeGestoraId);
				this.incluirSolicitacao.controls["internaResponsavelId"].setValue(res.dados.internaResponsavelId);
				this.incluirSolicitacao.controls["externaDestinatarioNome"].setValue(res.dados.externaDestinatarioNome);
				this.incluirSolicitacao.controls["externaDestinatarioResponsavel"].setValue(res.dados.externaDestinatarioResponsavel);

				const cpfCnpj = res.dados.externaDestinatarioCPFCNPJ?.replace(/\D/g, '') || '';
				this.incluirSolicitacao.controls["externaDestinatarioCPFCNPJ"].setValue(this.formatarCpfCnpj(cpfCnpj));

				const fone = res.dados.externaDestinatarioFone;
				this.telefoneFormatado = this.formatarTelefone(fone);
				this.incluirSolicitacao.controls['externaDestinatarioFone'].setValue(this.telefoneFormatado);

				this.incluirSolicitacao.controls["externaDestinatarioEmail"].setValue(res.dados.externaDestinatarioEmail);
				this.incluirSolicitacao.controls["assunto"].setValue(res.dados.assunto);
				this.incluirSolicitacao.controls["descricao"].setValue(res.dados.descricao);

				this.model.id = res?.dados?.id;
				this.model.status = res?.dados?.status
				this.model.numero = res.dados.numero
				this.model.prorrogarSolicitacao = res?.dados?.prorrogarSolicitacao

				this.dataSourceItems.paginator = this.paginator;
				this.dataSourceItems.sort = this.sort;
				this.dataSourceItems.sortingDataAccessor = this.sortingDataAccessor

				this.valorOriginal = this.incluirSolicitacao.getRawValue ? this.incluirSolicitacao.getRawValue() : this.incluirSolicitacao.value;
				this.habilitaFinalizarEnviar = true;

				if (this.visualizar) {
					this.incluirSolicitacao.controls['prazoResposta'].disable();
					this.incluirSolicitacao.controls['tipo'].disable();
					this.incluirSolicitacao.controls["internaUnidadeGestoraId"].disable();
					this.incluirSolicitacao.controls["internaResponsavelId"].disable();
					this.incluirSolicitacao.controls["externaDestinatarioNome"].disable();
					this.incluirSolicitacao.controls["externaDestinatarioResponsavel"].disable();
					this.incluirSolicitacao.controls["externaDestinatarioCPFCNPJ"].disable();
					this.incluirSolicitacao.controls['externaDestinatarioFone'].disable();
					this.incluirSolicitacao.controls["externaDestinatarioEmail"].disable();
					this.incluirSolicitacao.controls["assunto"].disable();
				}
				else {
					this.incluirSolicitacao.controls['prazoResposta'].enable();
					this.incluirSolicitacao.controls['tipo'].enable();
					this.incluirSolicitacao.controls["internaUnidadeGestoraId"].enable();
					this.incluirSolicitacao.controls["internaResponsavelId"].enable();
					this.incluirSolicitacao.controls["externaDestinatarioNome"].enable();
					this.incluirSolicitacao.controls["externaDestinatarioResponsavel"].enable();
					this.incluirSolicitacao.controls["externaDestinatarioCPFCNPJ"].enable();
					this.incluirSolicitacao.controls['externaDestinatarioFone'].enable();
					this.incluirSolicitacao.controls["externaDestinatarioEmail"].enable();
					this.incluirSolicitacao.controls["assunto"].enable();
				}

			} else {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "warning",
					text: res.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		});
	}

	public finalizar() {

		this.serviceSolicitacao
			.finalizar(this.model?.id)
			.then((res) => {
				if (res.sucesso) {
					this.model.status = res?.dados?.status;
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "success",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
				} else {
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "warning",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			});
	}

	public enviar() {
    console.log(this.model.id);
    console.log(this.tipoTrabalho?.nome);

		this.serviceSolicitacao
			.enviar(this.model?.id, this.tipoTrabalho?.nome)
			.then((res) => {
				if (res.sucesso) {
					this.model.status = res?.dados?.status;
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "success",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
					this.dialogRef.close()
				} else {
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "warning",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			});
	}

	public salvar(exibirModalAdicionarItem?: boolean) {

		this.submitted = true;
		if (this.incluirSolicitacao.invalid) {
			return;
		}

		var tipoSel = this.incluirSolicitacao.get("tipo")?.value;

		const dados = {
			id: this.model?.id,
			prazo: this.incluirSolicitacao.get("prazoResposta")?.value,
			assunto: this.incluirSolicitacao.get("assunto")?.value,
			descricao: this.incluirSolicitacao.get("descricao")?.value,
			tipoTrabalho: { codigo: this.tipoTrabalho.codigo },
			tipoTrabalhoId: this.data?.tipoTrabalhoId,
			tipo: tipoSel,
			internaUnidadeGestoraId: tipoSel === 1 ? this.incluirSolicitacao.get("internaUnidadeGestoraId")?.value : null,
			internaResponsavelId: tipoSel === 1 ? this.incluirSolicitacao.get("internaResponsavelId")?.value : null,
			externaDestinatarioNome: tipoSel === 2 ? this.incluirSolicitacao.get("externaDestinatarioNome")?.value : null,
			externaDestinatarioResponsavel: tipoSel === 2 ? this.incluirSolicitacao.get("externaDestinatarioResponsavel")?.value : null,
			externaDestinatarioCPFCNPJ: tipoSel === 2 ? this.incluirSolicitacao.get("externaDestinatarioCPFCNPJ")?.value?.replace(/\D/g, '') : null,
			externaDestinatarioFone: tipoSel === 2 ? this.incluirSolicitacao.get('externaDestinatarioFone')?.value?.replace(/\D/g, '') : null,
			externaDestinatarioEmail: tipoSel === 2 ? this.incluirSolicitacao.get("externaDestinatarioEmail")?.value : null,
		} as ISolicitacaoTecnicaModel;

		this.serviceSolicitacao
			.salvarSolicitacao(dados)
			.then((res) => {
				if (res.sucesso) {
					this.model.id = res?.dados?.id;
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "success",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
					if (exibirModalAdicionarItem) this.modalIncluiritem('Incluir', false);
				} else {
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "warning",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text: err.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			}).finally(() => {
				this.obterPorId();
			})
	}

	public modalIncluiritem(
		titulo: string,
		visualizar: boolean,
		element?: IItemSolicitacaoTecnicaModel
	) {
		if (!this.model?.id) {
			Swal.fire({
				toast: true,
				position: "top-end",
				title: "Atenção",
				icon: "warning",
				text: "Antes, salve as informações!",
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			});
			this.salvar(true)
		} else {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.id = "modal-component";
			dialogConfig.width = "45vw";
			dialogConfig.maxHeight = "90vh";
			dialogConfig.hasBackdrop = true;
			dialogConfig.disableClose = true;
			dialogConfig.data = {
				titulo,
				visualizar,
				id: this.model?.id,
				element,
				nSolicitacaoTecnica: this.numeroST
			};
			const modal = this.matDialog.open(
				OsaExecucaoModalIncluirItemComponent,
				dialogConfig
			);
			modal.afterClosed().subscribe((data) => {
				if (data) {
					this.obterPorId()
				}
			});
		}

	}

	public excluirItem(id: number) {
		Swal.fire({
			title: "Excluir Registro",
			text: "Tem certeza que deseja excluir esse Registro?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sim",
			cancelButtonText: "Não",
		}).then((res) => {
			if (res.value) {
				this.serviceSolicitacao
					.excluirItem(this.model?.id, id)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					})
					.catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							text: err.mensagem.descricao,
							icon: "error",
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					})
					.finally(() => {
						this.obterPorId()
					});
			}
		});
	}

	public cancelarItem(id: number) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component";
		dialogConfig.width = "45vw";
		dialogConfig.maxHeight = "85vh";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {};
		const modal = this.matDialog.open(
			ModalJustificativaComponent,
			dialogConfig
		);
		modal.afterClosed().subscribe((justificativa) => {
			if (justificativa) {

				const responsavelId = this.authService.usuario.id;

				this.serviceSolicitacao
					.cancelarItem(this.model?.id, id, justificativa, responsavelId)
					.then((res) => {
						if (res.sucesso) {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "success",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						} else {
							Swal.fire({
								toast: true,
								position: "top-end",
								icon: "warning",
								text: res.mensagem.descricao,
								showConfirmButton: false,
								timer: 5000,
								timerProgressBar: true,
							});
						}
					})
					.catch((err) => {
						Swal.fire({
							toast: true,
							position: "top-end",
							icon: "error",
							text: err.mensagem.descricao,
							showConfirmButton: false,
							timer: 5000,
							timerProgressBar: true,
						});
					})
					.finally(() => {
						this.obterPorId()
					});
			}
		});
	}

	public avaliar() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component";
		dialogConfig.width = "25vw";
		dialogConfig.maxHeight = "85vh";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			solicitacaoId: this.model?.id,
			data: this.model?.prorrogarSolicitacao?.data
		};
		const modal = this.matDialog.open(
			OsaExecucaoModalAvaliarProrrogacaoComponent,
			dialogConfig
		);
		modal.afterClosed().subscribe((data) => {
			this.obterPorId()
		});
	}

	public cancelar() {
		this.dialogRef.close();
	}

	public carregarTipoSolicitacaoTecnica() {
		this.tiposSolicitacaoTecnica = Object.keys(this.enumTipoSolicitacao)
			.filter(key => !isNaN(Number(key)))
			.map(key => ({
				text: this.enumTipoSolicitacao[Number(key)],
				value: Number(key)
			}));
	}

	public async obterUG(): Promise<void> {
		return this.serviceSolicitacao
			.obterUnidadeGestora(this.tipoTrabalho.nome, this.planejamentoId)
			.then((res) => {
				if (res.sucesso) {
					this.unidadesGetoras = res.dados;
				} else {
					Swal.fire({
						toast: true,
						position: "top-end",
						icon: "warning",
						text: res.mensagem.descricao,
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			});
	}

	public obterResponsaveis(id: any) {

		this.incluirSolicitacao.get("internaResponsavelId")?.reset();
		this.responsaveis = [];

		this.serviceSolicitacao.obterResponsaveis(id).then((res) => {
			if (res.sucesso) {
				this.responsaveis = res.dados;
			} else {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "warning",
					text: res.mensagem.descricao,
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		})
	}

	public controlaTipo() {
		this.incluirSolicitacao.get('tipo')?.valueChanges.subscribe((valor) => {
			if (valor === 1) {
				this.incluirSolicitacao.get('internaUnidadeGestoraId')?.setValidators(Validators.required);
				this.incluirSolicitacao.get('internaResponsavelId')?.setValidators(Validators.required);
				this.incluirSolicitacao.get('externaDestinatarioNome')?.clearValidators();
				this.incluirSolicitacao.get('externaDestinatarioResponsavel')?.clearValidators();
				this.incluirSolicitacao.get('externaDestinatarioEmail')?.clearValidators();

			} else if (valor === 2) {
				this.incluirSolicitacao.get('internaUnidadeGestoraId')?.clearValidators();
				this.incluirSolicitacao.get('internaResponsavelId')?.clearValidators();
				this.incluirSolicitacao.get('externaDestinatarioNome')?.setValidators(Validators.required);
				this.incluirSolicitacao.get('externaDestinatarioResponsavel')?.setValidators(Validators.required);
				this.incluirSolicitacao.get('externaDestinatarioEmail')?.setValidators([Validators.required, Validators.email]);
			}
			else {
				this.incluirSolicitacao.get('internaUnidadeGestoraId')?.clearValidators();
				this.incluirSolicitacao.get('internaResponsavelId')?.clearValidators();
				this.incluirSolicitacao.get('externaDestinatarioNome')?.clearValidators();
				this.incluirSolicitacao.get('externaDestinatarioResponsavel')?.clearValidators();
				this.incluirSolicitacao.get('externaDestinatarioEmail')?.clearValidators();
			}
			this.incluirSolicitacao.get('internaUnidadeGestoraId')?.updateValueAndValidity();
			this.incluirSolicitacao.get('internaResponsavelId')?.updateValueAndValidity();
			this.incluirSolicitacao.get('externaDestinatarioNome')?.updateValueAndValidity();
			this.incluirSolicitacao.get('externaDestinatarioResponsavel')?.updateValueAndValidity();
			this.incluirSolicitacao.get('externaDestinatarioEmail')?.updateValueAndValidity();
		});
	}

	onCpfCnpjInput(): void {
		const control = this.incluirSolicitacao.get('externaDestinatarioCPFCNPJ');
		let valor = control?.value || '';
		const numeros = valor.replace(/\D/g, '');

		if (numeros.length <= 11) {
			// CPF: 000.000.000-00
			valor = numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, function (_, p1, p2, p3, p4) {
				return `${p1}.${p2}.${p3}-${p4}`.replace(/[-.]+$/, '');
			});
		} else {
			// CNPJ: 00.000.000/0000-00
			valor = numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, function (_, p1, p2, p3, p4, p5) {
				return `${p1}.${p2}.${p3}/${p4}-${p5}`.replace(/[-/.]+$/, '');
			});
		}

		control?.setValue(valor, { emitEvent: false });
	}

	formatarCpfCnpj(valor: string): string {
		if (!valor) return '';

		const digits = valor.replace(/\D/g, '');

		if (digits.length <= 11) {
			return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
		} else {
			return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
		}
	}

	formatarTelefone(digits: string): string {
		if (!digits) return '';

		const apenasNumeros = digits.replace(/\D/g, '');

		if (apenasNumeros.length === 11) {
			// Celular: (00) 00000-0000
			return apenasNumeros.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
		} else if (apenasNumeros.length === 10) {
			// Fixo: (00) 0000-0000
			return apenasNumeros.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
		}

		return apenasNumeros; // Retorna só os dígitos se não bater com formatos esperados
	}

	onTelefoneInput(event: any): void {
		const input = event.target.value || '';
		this.telefoneFormatado = this.formatarTelefone(input);
		this.incluirSolicitacao.get('externaDestinatarioFone')?.setValue(this.telefoneFormatado, { emitEvent: false });
	}

	dateRangeValidator(control: AbstractControl): { [key: string]: any } | null {

		if (!control.value) return null;

		const selectedDate = this.truncateDate(new Date(control.value));

		if (selectedDate < this.dataHoje) {
			return { dataMenorHoje: true };
		}

		if (this.dataPrazoLimite && selectedDate > this.dataPrazoLimite) {
			return { dataMaiorLimite: true };
		}

		return null;
	}

	private truncateDate(date: Date): Date {
		return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	}

	public isStatusAvaliacaoVazio(status: any): boolean {
		return !status || Object.keys(status).length === 0;
	}

	formatarTooltipAvaliacao(element: any): string {
		const data = element?.dataHoraAvaliacao
			? new Date(element.dataHoraAvaliacao).toLocaleDateString('pt-BR')
			: 'Data não informada';

		const nome = element?.responsavelNomeAvaliacao || 'Avaliador desconhecido';
		const comentario = element?.comentarioAvaliacao || 'Sem comentário';

		return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
	}

	formatarTooltipCanc(element: any): string {

		const data = element?.dataHoraCanc
			? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
			: 'Data não informada';

		const nome = element?.responsavelNomeCanc || 'Usuário desconhecido';
		const comentario = element?.justificativa || 'Sem comentário';

		return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
	}

	private formsIguais(obj1: any, obj2: any): boolean {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}

}

// ✅ FORA DA CLASSE COMPONENTE
function cpfCnpjValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value?.replace(/\D/g, '');

	if (!value) return null;

	if (value.length === 11) {
		return validarCPF(value) ? null : { cpfCnpjInvalido: true };
	} else if (value.length === 14) {
		return validarCNPJ(value) ? null : { cpfCnpjInvalido: true };
	} else {
		return { cpfCnpjInvalido: true };
	}
}

function validarCPF(cpf: string): boolean {
	if (/^(\d)\1+$/.test(cpf)) return false;
	let soma = 0;
	for (let i = 0; i < 9; i++) soma += parseInt(cpf[i]) * (10 - i);
	let resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf[9])) return false;
	soma = 0;
	for (let i = 0; i < 10; i++) soma += parseInt(cpf[i]) * (11 - i);
	resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	return resto === parseInt(cpf[10]);
}

function validarCNPJ(cnpj: string): boolean {
	if (/^(\d)\1+$/.test(cnpj)) return false;
	let tamanho = cnpj.length - 2;
	let numeros = cnpj.substring(0, tamanho);
	let digitos = cnpj.substring(tamanho);
	let soma = 0;
	let pos = tamanho - 7;
	for (let i = tamanho; i >= 1; i--) {
		soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
		if (pos < 2) pos = 9;
	}
	let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	if (resultado !== parseInt(digitos.charAt(0))) return false;

	tamanho += 1;
	numeros = cnpj.substring(0, tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (let i = tamanho; i >= 1; i--) {
		soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
		if (pos < 2) pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	return resultado === parseInt(digitos.charAt(1));
}
